class VehicleTypeModel{
    vehicleTypeId:number;
    name?: string;
    notes?:string;
    isActive?:boolean;
  
}
export default VehicleTypeModel